import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../assets/css/mainMenu.css";
import "../../assets/css/addunit.css";
import visible from "../../assets/icons/visible 1.svg";
import closeIcon from "../../assets/icons/close.svg";
import fetchWrapper from "../../AuthMiddleware/FetchWrapper";
import Loader from "../../Components/LoaderAndSpinner/Loader";
import MultiSelectDropdown from "../../Components/MultiSelectDropdown/MultiSelectDropdown";
import Pagination from "../../Components/Pagination/Pagination";
const SvpMapping = () => {
  const [svps, setSvps] = useState([]);
  const [groupedData, setGroupedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedSPVs, setSelectedSPVs] = useState([]);
  const navigate = useNavigate();
  const [viewData, setviewdata] = useState([]);
  const [tooltipid, setTooltipid] = useState(null);
  const [viewmodal, setViewModal] = useState(false);
  const [showSvpModal, setShowSvpModal] = useState(false);
  
  // Pagination states for main table
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  
  // Pagination states for SVP dropdown
  const [svpPage, setSvpPage] = useState(1);
  const [svpSearch, setSvpSearch] = useState("");
  const [svpTotalItems, setSvpTotalItems] = useState(0);
  const [svpLoading, setSvpLoading] = useState(false);
  const [masterId, setMasterId] = useState(null);
  const searchTimeoutRef = React.useRef(null);
  
  // Reset to page 1 when groupedData changes
  useEffect(() => {
    setCurrentPage(1);
  }, [groupedData]);
  
  // Fetch master ID on mount
  useEffect(() => {
    const getMasterId = async () => {
      try {
        const data = await fetchWrapper(
          `${process.env.REACT_APP_BASE_API_URL1}/api/v1/get-svp`,
          { method: "POST", body: JSON.stringify({}) }
        );
        console.log("Master ID fetched:", data._id);
        setMasterId(data._id);
      } catch (error) {
        console.error(":x: Error fetching master ID:", error.message);
        if (error.message === "Unauthorized") navigate("/auth/login");
      }
    };
    getMasterId();
  }, [navigate]);

  // Fetch SVPs with pagination
  const fetchSvps = async (page = 1, search = "") => {
    if (!masterId) {
      console.log("No masterId available yet");
      return;
    }
    
    console.log(`Fetching SVPs - Page: ${page}, Search: "${search}", MasterId: ${masterId}`);
    setSvpLoading(true);
    try {
      const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/dynamic-data/${masterId}/paginate?page=${page}&limit=10&search=${encodeURIComponent(search)}`;
      console.log("API URL:", url);
      
      const result = await fetchWrapper(
        url,
        { 
          method: "POST",
          body: JSON.stringify({})
        }
      );
      console.log(":white_check_mark: SVPs Response:", result);
      console.log("SVPs Data:", result.data);
      console.log("Total Items:", result.totalItems);
      
      setSvps(result.data || []);
      setSvpTotalItems(result.totalItems || 0);
    } catch (error) {
      console.error(":x: Error fetching SVPs:", error);
      console.error("Error message:", error.message);
      if (error.message === "Unauthorized") navigate("/auth/login");
    } finally {
      setSvpLoading(false);
    }
  };

  // Fetch SVPs when masterId, page, or search changes
  useEffect(() => {
    if (masterId) {
      fetchSvps(svpPage, svpSearch);
    }
  }, [masterId, svpPage, svpSearch]);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);
  const handleSelectionChange = (selectedItems) => {
    setSelectedSPVs(selectedItems);
  };
  const handleSvpPageChange = (page) => {
    setSvpPage(page);
  };

  // Handle SVP dropdown search with debouncing
  const handleSvpSearch = (searchValue, page = 1) => {
    setSvpSearch(searchValue);
    setSvpPage(page);
  };

  // Debounced search handler for modal input
  const handleDebouncedSearch = (value) => {
    // Clear existing timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    // Set new timeout (500ms delay)
    searchTimeoutRef.current = setTimeout(() => {
      handleSvpSearch(value, 1);
    }, 500);
  };
 const handleview = async (assets) => {
  console.log("Fetching preview for assets:", assets);
  setLoading(true);
  setViewModal(true);
  try {
    // Fetch all equipment previews
    const previewPromises = assets.map(asset =>
      fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipments/preview/${asset.full._id}`,
      {
        method: "POST",
        body: JSON.stringify({}),
      },
      navigate
      )
    );
    
    const previewResponses = await Promise.all(previewPromises);
    const allEquipmentData = previewResponses.map(response => response.data);
    
    console.log("preview data:", allEquipmentData);
    setviewdata(allEquipmentData || []); // store as array
  } catch (error) {
    console.error("Error fetching preview data:", error.message);
    if (error.message === "Unauthorized") navigate("/auth/login");
  } finally {
    setLoading(false);
  }
};
const fetchMasterData = async (selectedSPVs) => {
  console.log("selected svpppppppp", selectedSPVs);
  if (!selectedSPVs || selectedSPVs.length === 0) {
    setGroupedData([]);
    return [];
  }
  try {
    const response = await fetchWrapper(
      `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipment/getall`,
      { method: "POST", body: JSON.stringify({}), headers: { "Content-Type": "application/json" } }
    );
    const allEquipments = response.data || [];
    if (allEquipments.length === 0) {
      setGroupedData([]);
      return [];
    }
    const deepSearchInObject = (obj, terms) => {
      if (!obj) return false;
      if (typeof obj === "string" || typeof obj === "number" || typeof obj === "boolean") {
        return terms.some(term => term && String(obj).toLowerCase().includes(term));
      }
      if (Array.isArray(obj)) return obj.some(v => deepSearchInObject(v, terms));
      if (typeof obj === "object") return Object.values(obj).some(v => deepSearchInObject(v, terms));
      return false;
    };
    const normalizeTerms = (spv) =>
      [spv.var_prcs_txt, spv.var_prcs_code, spv._id, spv.asset_id]
        .map(v => (v ? String(v).toLowerCase() : null))
        .filter(Boolean);
    const equipmentMatchesSpv = (eqpt, spv) => {
      if (eqpt.asset_id && spv.asset_id && String(eqpt.asset_id) === String(spv.asset_id)) return true;
      const terms = normalizeTerms(spv);
      if (!terms.length) return false;
      if (deepSearchInObject(eqpt.templates, terms)) return true;
      if (deepSearchInObject(eqpt, terms)) return true;
      return false;
    };
    const grouped = selectedSPVs.map(spv => {
      // Filter matching equipments
      const matchedEquipments = allEquipments.filter(eqpt => equipmentMatchesSpv(eqpt, spv));
      // Map and ensure unique assets using a Set
      const seenAssetIds = new Set();
      const assets = matchedEquipments
        .map(eqpt => {
          const id = eqpt.asset_id || eqpt._id;
          if (seenAssetIds.has(id)) return null; // skip duplicates
          seenAssetIds.add(id);
          return {
            asset_id: id,
            asset_name: eqpt.equipment_name || eqpt.equipment_code || eqpt.name || "",
            full: eqpt
          };
        })
        .filter(Boolean); // remove nulls
      return { spv, assets };
    });
    setGroupedData(grouped);
    return grouped;
  } catch (error) {
    console.error(" Error fetching equipments:", error);
    setGroupedData([]);
    return [];
  }
};

  // Pagination calculations
  const totalItems = groupedData.length;
  const totalPages = Math.ceil(totalItems / pageSize);
  const startIndex = (currentPage - 1) * pageSize + 1;
  const endIndex = Math.min(currentPage * pageSize, totalItems);
  const paginatedData = groupedData.slice(startIndex - 1, endIndex);

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Handle page size change
  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1); // Reset to first page when page size changes
  };

  return (
    <>
      {loading && <Loader />}
      <div className="container">
        <div className="pt-3 pb-0 d-flex justify-content-between">
          <div>
            <h5>SPV Mapping</h5>
            <nav className="breadcrumb-nav" aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="#" style={{ textDecoration: "none" }}>Review</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">SPV Mapping</li>
              </ol>
            </nav>
          </div>
          <div className="d-flex gap-3 align-items-start">
            <button 
              type="button" 
              className="btn-bg" 
              onClick={() => setShowSvpModal(true)}
            >
              Select SPVs ({selectedSPVs.length} selected)
              </button>
          </div>
        </div>
        <div className="table-responsive mt-3">
          <table className="table align-middle table-text">
            <thead className="table-head align-middle">
              <tr>
                <th className="col text-uppercase">SPV Code</th>
                <th className="col text-uppercase">SPV Name</th>
                <th className="col text-uppercase">No of Assets</th>
                <th className="col-2 text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.length === 0 ? (
                <tr>
                  <td colSpan="100%" className="text-center">No data available</td>
                </tr>
              ) : (
                paginatedData.map((item, index) => {
                  const { spv, assets } = item;
                  return (
                    <tr key={index}>
                      <td>{spv.var_prcs_code}</td>
                      <td>{spv.var_prcs_txt || "-"}</td>
                      <td>{assets.length}</td>
                      <td className="text-center">
                        {assets.length > 0 ? (
                                <button
                            style={{ border: "none", background: "transparent", cursor: "pointer" }}
                            className="align-content-center"
                            onClick={() => handleview(assets)}
                            title="View Equipment"
                          >
                            <img src={visible} alt="View" style={{ width: "20px", height: "20px" }} />
                                </button>
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
        
        {/* Pagination */}
        {groupedData.length > 0 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            pageSize={pageSize}
            onPageSizeChange={handlePageSizeChange}
            totalItems={totalItems}
            startIndex={startIndex}
            endIndex={endIndex}
          />
        )}
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        
        {/* SVP Selection Modal */}
        {showSvpModal && (
          <div
            id="overlay"
            className="modal fade show"
            tabIndex="-1"
            role="dialog"
            style={{
              zIndex: 30,
              display: "block",
              backgroundColor: "rgba(0,0,0,0.5)",
            }}
          >
            <div className="addunit-card" style={{ width: "50%", maxWidth: "800px", height: "90vh", display: "flex", flexDirection: "column" }}>
              <div className="addunit-header">
                <h4>Select SPVs</h4>
                <button
                  style={{ border: "none", backgroundColor: "inherit" }}
                  type="button"
                  className="close"
                  onClick={() => setShowSvpModal(false)}
                >
                  <img src={closeIcon} width="28px" height="28px" alt="Close" />
                </button>
              </div>

              <div className="addunit-form" style={{ flex: "1", overflow: "hidden", padding: "20px" }}>
                {/* Search Input */}
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search SPVs..."
                    onChange={(e) => handleDebouncedSearch(e.target.value)}
                  />
                  {svpLoading && (
                    <small className="text-muted">Searching...</small>
                  )}
                </div>

                {/* SVP List */}
                <div style={{ height: "400px", overflowY: "auto" }}>
                  {svpLoading ? (
                    <div className="text-center p-3">Loading...</div>
                  ) : svps.length > 0 ? (
                    <table className="table table-bordered table-hover">
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: "50px", textAlign: "center", verticalAlign: "middle" }}>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                              <input
                                type="checkbox"
                                style={{ width: "16px", height: "16px", margin: "0" }}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelectedSPVs(svps);
                                  } else {
                                    setSelectedSPVs([]);
                                  }
                                }}
                                checked={selectedSPVs.length === svps.length && svps.length > 0}
                              />
                            </div>
                          </th>
                          <th>SPV Code</th>
                          <th>SPV Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        {svps.map((svp) => (
                          <tr key={svp._id}>
                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <input
                                  type="checkbox"
                                  style={{ width: "16px", height: "16px", margin: "0" }}
                                  checked={selectedSPVs.some(selected => selected._id === svp._id)}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedSPVs([...selectedSPVs, svp]);
                                    } else {
                                      setSelectedSPVs(selectedSPVs.filter(s => s._id !== svp._id));
                                    }
                                  }}
                                />
                              </div>
                            </td>
                            <td>{svp.var_prcs_code}</td>
                            <td>{svp.var_prcs_txt}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div className="text-center p-3">No SPVs found</div>
                  )}
                </div>

                {/* Pagination Controls */}
                {svpTotalItems > 10 && (
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <button
                      className="btn btn-sm btn-secondary"
                      onClick={() => handleSvpPageChange(svpPage - 1)}
                      disabled={svpPage === 1}
                    >
                      Previous
                    </button>
                    <span>
                      Page {svpPage} of {Math.ceil(svpTotalItems / 10)}
                    </span>
                    <button
                      className="btn btn-sm btn-secondary"
                      onClick={() => handleSvpPageChange(svpPage + 1)}
                      disabled={svpPage >= Math.ceil(svpTotalItems / 10)}
                    >
                      Next
                    </button>
                  </div>
                )}

              </div>

              {/* Footer with Selected Count and Submit Button */}
              <div className="addunit-card-footer" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontSize: "14px", color: "#666" }}>Selected: {selectedSPVs.length} / {svpTotalItems}</span>
                <button
                  className="btn-bg"
                  onClick={() => {
                    if (selectedSPVs.length > 0) {
                      fetchMasterData(selectedSPVs);
                      setShowSvpModal(false);
                    } else {
                      alert("Please select at least one SPV");
                    }
                  }}
                  disabled={selectedSPVs.length === 0}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Equipment Preview Modal */}
        <div
          id="overlay"
          className={`modal fade ${viewmodal ? "show" : ""}`}
          tabIndex="-1"
          role="dialog"
          style={{
            zIndex: 30,
            display: viewmodal ? "block" : "none",
            transition: "width 2s",
          }}
        >
          {loading ? (
            <Loader />
          ) : (
            <div className="addunit-card" style={{ width: "95%", maxWidth: "100%", height: "95vh" }}>
              <div className="addunit-header">
                <h4>Equipment Preview</h4>
                <button
                  style={{ border: "none", backgroundColor: "inherit" }}
                  type="button"
                  className="close"
                  onClick={() => setViewModal(false)}
                >
                  <img src={closeIcon} width="28px" height="28px" alt="Close" />
                </button>
              </div>

              <div className="addunit-form" style={{ maxHeight: "calc(95vh - 120px)", overflowY: "auto" }}>
                {viewData && viewData.length > 0 ? (
                  (() => {
                    // Get all unique keys from all equipment objects
                    const allKeys = new Set();
                    viewData.forEach(equipment => {
                      if (equipment && typeof equipment === 'object') {
                        Object.keys(equipment).forEach(key => {
                          // Exclude certain fields like _id, __v, templates, created_at, updated_at
                          if (!['_id', '__v', 'templates', 'created_at', 'updated_at', 'asset_groups'].includes(key)) {
                            allKeys.add(key);
                          }
                        });
                      }
                    });
                    const headers = Array.from(allKeys);
                    
                    // Helper function to format key names
                    const formatHeader = (key) => {
                      return key
                        .split('_')
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(' ');
                    };
                    
                    return (
                      <table className="table table-bordered align-middle">
                        <thead className="table-head text-uppercase">
                          <tr>
                            {headers.map((header, index) => (
                              <th key={index}>{formatHeader(header)}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {viewData.map((equipment, rowIndex) => (
                            <tr key={rowIndex}>
                              {headers.map((header, colIndex) => (
                                <td key={colIndex}>
                                  {typeof equipment?.[header] === 'object' 
                                    ? JSON.stringify(equipment[header]) 
                                    : equipment?.[header] || "-"}
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    );
                  })()
                ) : (
                  <p className="text-center">No data available</p>
                )}
              </div>

              
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default SvpMapping;